import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetRolesPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/inputs/get-roles-paginated.form-default-values';
import { GetRolesPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/inputs/get-roles-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterSearchRoleListContextProvider,
  useRoleListContext,
} from '../role.context';
import { RoleListFilterSearchFormController } from './role-list-filter-search-form/role-list-filter-search-form.controller';

interface RoleListFilterSearchControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const RoleListFilterSearchController = ({
  onCancel,
  onSuccess,
}: RoleListFilterSearchControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useRoleListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetRolesPaginatedModel> = (errors) => {
    Logger.error(errors);
    toast.error(
      t('$.role-list-filter-search.error', { error: t('global.unknown') }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<GetRolesPaginatedModel> = (
    fieldValues,
  ) => {
    setGetPaginatedQueryParameters((current) => {
      return {
        ...current,
        textToSearch: fieldValues.textToSearch,
      };
    });
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetRolesPaginatedDefaultValues(getPaginatedQueryParameters);

  return (
    <FilterSearchRoleListContextProvider data={data}>
      <RoleListFilterSearchFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </FilterSearchRoleListContextProvider>
  );
};
